import { useCallback } from "books/act";
import { Tooltip, IconButton } from "fashion/fabrics";
import { ShareIcon } from "fashion/icons";
import { BlogPost } from "names/blog";

type Props = {
  post: BlogPost;
};

const BlogHeaderShare = ({ post }: Props) => {
  const handleShare = useCallback(async () => {
    if (!navigator.share) {
      return;
    }
    try {
      await navigator.share({
        title: document.title,
        text: `Article from ${post.date}`,
        url: post.route,
      });
    } catch (error) {}
  }, [post]);

  return (
    <Tooltip title="Share Blog Article">
      <IconButton onClick={handleShare} color="secondary">
        <ShareIcon />
      </IconButton>
    </Tooltip>
  );
};

export default BlogHeaderShare;
